import styled from "styled-components";

const BotonRegresar = styled.button`
  height: 50px;
  width: 25%;
  color: #fff;
  background-image: -webkit-linear-gradient(144deg,#1A1594, #1A1594 30%,#257cb6);
  border-radius: 20px;
  margin-top: 5%;
  border: none;

  &:hover {
    background-color: #100d58 !important;
    font-size: large;
  }

  @media (max-width: 900px) {
    width: 45%;
  }

`;


export default BotonRegresar;